import React from 'react';
import { Link } from 'react-router-dom';

function MenuInteremedioActividades() {
  return (
    <div className="p-1 bg-light" style={styles.container}>
      <Link to="/deportes" style={styles.link}>
        <button style={styles.boton}>Educación Física</button>
      </Link>
      <Link to="/ArteActividad" style={styles.link}>
        <button style={styles.boton}>Arte</button>
      </Link>
      <Link to="/actividades" style={styles.link}>
        <button style={styles.boton}>Comunidad Activa</button>
      </Link>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    flexWrap: 'wrap',                 
    justifyContent: 'space-around', 
  },
  link: {
    flex: '1 1 30%',  
    minWidth: '140px',
    textAlign: 'center',
  },
  boton: {
    width: '100%', 
    padding: '1rem',
    backgroundColor: 'transparent',
    color: 'green',
    fontWeight: 'bold',
    fontSize: '1.1rem',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    whiteSpace: 'normal',
  },
};

export default MenuInteremedioActividades;
